import { useEffect } from "react";
import { PixelScene } from "./components/pixel-scene";
import { StoryForm } from "./components/story-form";
import { JobList } from "./components/job-list";
import { OwnerModelPanel } from "./components/owner-model-panel";
import { useJobs } from "./hooks/use-jobs";
import { getModelExperience } from "./model-experience";

export function App(): React.JSX.Element {
  const telegram = window.Telegram?.WebApp;
  const initData = telegram?.initData ?? "";
  const {
    jobs,
    session,
    settings,
    loading,
    submitting,
    savingSettings,
    error,
    create,
    updateVideoModel,
  } = useJobs(initData);
  const firstName = session?.user.firstName;
  const activeModel = settings?.activeVideoModel ?? "sora-2";
  const experience = getModelExperience(activeModel);

  useEffect(() => {
    telegram?.ready();
    telegram?.expand();
  }, [telegram]);

  useEffect(() => {
    document.documentElement.dataset.videoModel = activeModel;
  }, [activeModel]);

  return (
    <main className="studio-root" data-model={activeModel}>
      <header className="hero">
        <nav>
          <div className="brand-mark">FV</div>
          <div className="brand-copy">
            <strong>FARZIN</strong>
            <span>VIDEO MAKER</span>
          </div>
          <div className="online-pill">
            <i /> {experience.onlineLabel}
          </div>
        </nav>
        <PixelScene />
        <div className="hero-copy">
          <span className="eyebrow">{experience.eyebrow}</span>
          <h1>
            {firstName ? `Hi ${firstName}. ` : ""}
            {experience.heroLead}
            <br />
            <em>{experience.heroEmphasis}</em>
          </h1>
          <p>{experience.description}</p>
        </div>
      </header>

      <div className="content-shell">
        {!initData ? (
          <div className="warning-banner pixel-border">
            Open this Mini App from the Farzin Video Maker Telegram bot to
            create videos.
          </div>
        ) : null}
        {error ? (
          <div className="error-banner pixel-border" role="alert">
            {error}
          </div>
        ) : null}
        {session?.isOwner && settings ? (
          <OwnerModelPanel
            settings={settings}
            saving={savingSettings}
            onChange={updateVideoModel}
          />
        ) : null}
        <StoryForm
          key={activeModel}
          disabled={!initData || submitting || !settings}
          model={activeModel}
          onSubmit={create}
        />
        <JobList jobs={jobs} loading={loading} />
      </div>
      <footer>
        <span>FARZIN VIDEO MAKER</span>
        <span>ORIGINAL PIXEL FILMS · 2026</span>
      </footer>
    </main>
  );
}
